import React, { useEffect, useState } from 'react'
import { useFormikContext } from 'formik'
import { useDispatch } from 'react-redux'

import { matchingSiteCount } from '../../../../actions/requestFormActions'

import Selector from './Selector'

const SitesSelector = () => {
  const dispatch = useDispatch()
  const requestForm = useFormikContext()
  const [lastValues, setLastValues] = useState({})

  // TODO: This feels like a hack. Got to be a better way to not duplicate api requests
  useEffect(() => {
    if (JSON.stringify(requestForm.values) !== lastValues) {
      dispatch(matchingSiteCount(requestForm.values))
    }
    setLastValues(JSON.stringify(requestForm.values))
  }, [requestForm.values])

  const handleSiteSelector = (siteIds, matchingSitesCount) => {
    requestForm.setFieldValue('specificSiteIds', siteIds)
    requestForm.setFieldValue('matchingSitesCount', matchingSitesCount)
  }
  return <Selector onChange={handleSiteSelector} siteIds={requestForm.values.specificSiteIds} />
}

export default SitesSelector
